 const validate = (value, rules, state) => {
  let isValid = true;
  let brokenRule = "";
  for (let rule in rules) {
    switch (rule) {
      case "minLength":
        isValid = isValid && minLengthValidator(value, rules[rule]);
        break;

      case "maxLength":
        isValid = isValid && maxLengthValidator(value, rules[rule]);
        break;

      case "matchPattern":
        isValid = isValid && patternValidator(value, rules[rule]);
        break;

      case "shouldNotMatchPattern":
        isValid = isValid && reversePatternValidator(value, rules[rule]);
        break;

      case "isRequired":
        isValid = isValid && requiredValidator(value, rules[rule]);
        break;

      case "isEmail":
        isValid = isValid && emailValidator(value);
        break;

      case "isZipCode":
        isValid = isValid && zipCodeValidator(value);
        break;

      case "isValidPercent":
        isValid = isValid && percentValidator(value);
        break;

      case "lessThanValue":
        isValid = isValid && lessThanValidator(value, rules[rule]);
        break;

      case "greaterThanValue":
        isValid = isValid && greaterThanValidator(value, rules[rule]);
        break;

      case "dependentOn":
        isValid = isValid && dependentValidator(value, rules[rule], state);
        break;

      case "optionDependentWith":
        isValid =
          isValid && optionDependentValidator(value, rules[rule], state);
        break;

      default:
        isValid = true;
    }
    if (!isValid) {
      brokenRule = rule;
      break;
    }
  }

  return brokenRule;
};

/**
 * minLength Val
 * @param  value
 * @param  minLength
 * @return
 */
const minLengthValidator = (value, minLength) => {
  if (value) return value.length >= minLength;
  return true;
};

/**
 * maxLength Val
 * @param  value
 * @param  maxLength
 * @return
 */
export const maxLengthValidator = (value, maxLength) => {
  if (value) return value.length <= maxLength;
  return true;
};

/**
 * Check to confirm that feild is required
 *
 * @param  value
 * @param  isRequired
 * @return
 */
export const requiredValidator = (value, isRequired) => {
  if (isRequired) {
    if (value && value !== "") {
      return value.toString().trim() !== "";
    }
    return !!value;
  }
  return true;
};

/**
 * Email validation
 *
 * @param value
 * @return
 */

export const emailValidator = value => {
  if (value) {
    let emailRegEx = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return emailRegEx.test(String(value).toLowerCase());
  }
  return true;
};

/**
 * Match a specificed regular expression
 *
 * Avoid using this, make specific validators
 *
 * @param value
 * @param regExPattern
 * @return
 */
export const patternValidator = (value, regExPattern) => {
  return regExPattern.test(String(value));
};

/**
 * Match a specificed regular expression
 *
 * Avoid using this, make specific validators
 *
 * @param value
 * @param regExPattern
 * @return
 */
export const reversePatternValidator = (value, regExPattern) => {
  return !regExPattern.test(String(value));
};

/**
 * ZipCode validation (xxxxx or xxxxx-xxxx)
 *
 * @param value
 * @return
 */
export const zipCodeValidator = value => {
  if (value.length < 5) {
    return false;
  }
  return true;
};

/**
 * Checks if number is above 0 and equal or less than 100
 *
 * @param value
 * @return
 */
export const percentValidator = value => {
  return parseInt(value) > 0 && parseInt(value) <= 100;
};

/**
 * Checks if number is less than value provided for comparison
 *
 * @param value
 * @param comparison
 * @return
 */
export const lessThanValidator = (value, comparison) => {
  if (comparison) return parseFloat(value) <= parseFloat(comparison);
  return true;
};

/**
 * Checks if number is greater than value provided for comparison
 *
 * @param value
 * @param comparison
 * @return
 */
export const greaterThanValidator = (value, comparison) => {
  if (comparison) return parseFloat(value) >= parseFloat(comparison);
  return true;
};

export const dependentValidator = (value, key, state) => {
  if (state[key] && state[key].value) {
    if (value.trim) {
      return value.trim() !== "";
    }
    return !!value;
  }
  return true;
};

export const optionDependentValidator = (value, key, state) => {
  if (state[key] && state[key].value) {
    return true;
  } else {
    if (value) {
      return true;
    }
    return false;
  }
};

export default validate;
